import { CloseOutlined } from '@ant-design/icons';
import { Avatar, Button, Divider, Popover, Spin, Typography } from 'antd';
import { ReactComponent as ChevronDownIcon } from 'assets/icons/ChevronDown.svg';
import { ReactComponent as UserCheckIcon } from 'assets/icons/UserCheck.svg';
import { useAuthContext } from 'contexts/AuthContext';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ContactPopover = () => {
  const { t } = useTranslation('contact');
  const [open, setOpen] = useState(false);
  const { owner: data, ownerIsLoading: isLoading } = useAuthContext();

  return (
    <Popover
      onOpenChange={(visible) => setOpen(visible)}
      open={open}
      rootClassName={'no-padding-popover white-popover'}
      content={
        <div className={''}>
          <div className={'flex justify-between items-center pl-6 pr-3 py-3'}>
            <Typography.Paragraph className={'!mb-0 font-bold'}>
              {t('title')}
            </Typography.Paragraph>
            <Button
              type={'text'}
              icon={<CloseOutlined />}
              onClick={() => setOpen(false)}
            />
          </div>
          <Divider className={'m-0'} />
          <div className={'py-4 px-6'}>
            {isLoading && <Spin className={'mx-auto'} />}
            {!isLoading && !data?.email && (
              <Typography.Paragraph className={'!mb-0'}>
                {t('no_contact')}
              </Typography.Paragraph>
            )}
            {data && data.email && (
              <Typography.Paragraph className={'!mb-0 font-bold leading-8'}>
                {data.firstname} {data.lastname} <br />
                {t('global:phone')}:{' '}
                <a href={`tel:${data.phone}`}>{data.phone}</a>
                <br />
                {t('global:email')}:{' '}
                <a href={`mailto:${data.email}`}>{data.email}</a>
              </Typography.Paragraph>
            )}
          </div>
        </div>
      }
      placement={'bottomRight'}
    >
      <Button
        type="default"
        className="bg-vert-transport-1 hover:!bg-vert-transport-1 border-0 flex items-center gap-3 !pl-1"
        shape="round"
        size="large"
      >
        <Avatar
          icon={<UserCheckIcon />}
          className="bg-vert-transport-10 !flex justify-center items-center"
          size={30}
        />
        <span className="text-vert-transport-10 font-medium text-base">
          {t('title')}
        </span>
        <ChevronDownIcon className="text-vert-transport-10 text-xs ml-2" />
      </Button>
    </Popover>
  );
};
